import { getCasedHeadingTextBasedOnStyleOverrides } from 'src/mentor/components/PrescriptionMakingPage/printComponents/printComponents/prescriptionPrintableItems/util'
import { PRESCRIPTION_COLORS_MAP } from '../../../inputComponents/common/color-utils'
import { PMPBodySectionItems } from './styledComponent'

export default function PrintableAssessments({
  assessmentsRef,
  debug,
  selectedAssessments,
  debugHighlightStates,
  noPadding = false,
  styleOverrides,
}) {
  return (
    <PMPBodySectionItems
      ref={assessmentsRef}
      debug={debug}
      noPadding={noPadding}
      debugColor={PRESCRIPTION_COLORS_MAP.selectedTherapy.color}
      debugHighlight={debugHighlightStates?.assessments}
    >
      <span
        style={{
          fontSize: styleOverrides?.headingFontSize
            ? `${styleOverrides?.headingFontSize}px`
            : 'inherit',
          color: styleOverrides?.headingColor || 'inherit',
        }}
      >
        <strong>
          {getCasedHeadingTextBasedOnStyleOverrides({
            headingText: `Psych Assessments Needed`,
            styleOverrides,
          })}
        </strong>
      </span>
      <div>{selectedAssessments.map((assessmentItem) => assessmentItem.label).join(', ')}</div>
    </PMPBodySectionItems>
  )
}
